import { UserStatus } from "models/status/status";
import { getStorage } from "./storage";

const webStorage = getStorage();

export function getTabToken() {
  return webStorage.getItem("token");
}

export function setTabToken(token: string) {
  webStorage.setItem("token", token);
}

export function getCompanyName() {
  return webStorage.getItem("companyName");
}

export function setCompanyName(companyName: string) {
  webStorage.setItem("companyName", companyName);
}

export function clearCompanyName() {
  webStorage.removeItem("companyName");
}

export function clearTabToken() {
  webStorage.removeItem("token");
}

export function getIntendedPath() {
  return webStorage.getItem("intendedPath");
}

export function setIntendedPath(path: string) {
  webStorage.setItem("intendedPath", path);
}

export function clearIntendedPath() {
  webStorage.removeItem("intendedPath");
}

const INITIAL_REDIRECT_FLAG = "hasPerformedInitialRedirect";

export function hasPerformedInitialRedirect(): boolean {
  return webStorage.getItem(INITIAL_REDIRECT_FLAG) === "true";
}

export function markInitialRedirectAsPerformed(): void {
  webStorage.setItem(INITIAL_REDIRECT_FLAG, "true");
}

function clearInitialRedirectFlag(): void {
  webStorage.removeItem(INITIAL_REDIRECT_FLAG);
}

export function updateBrowserStatus(user: UserStatus) {
  const sum = user.unhandledUploads + user.unreadThreads;

  if (sum > 0) {
    document.title = "(" + sum + ") MittKontor";
  } else {
    document.title = "MittKontor";
  }
}

export function logoutUser() {
  clearTabToken();
  clearIntendedPath();
  clearInitialRedirectFlag();
}
